import React from "react";
import Box from "@mui/material/Box";
import { useSelector } from "react-redux";
import BreadCrumb from "app/components/BreadCrumb";
import { useTranslation } from "react-i18next";
import { useInjectReducer } from "redux-injectors";
import { ActionBar } from "../components/ActionBar";
import { reducer, sliceKey } from "../../../redux/slice";

import { useStyles } from "./styles";
import CatalogItemsTable from "../components/CatalogItemsTable";
import { selectCatalogItems, selectIsLoading } from "../../../redux/selector";

import { AdminCatalogTableRow } from "../../../types";
import { useLocation, useNavigate } from "react-router-dom";
import CatalogDetails from "../components/CatalogDetails";
import AddCatalogItemModal from "../../AddCatalogItemModal";

const AdminCatalogItems = () => {
  const styles = useStyles();
  const { t, i18n } = useTranslation();
  const rows = useSelector(selectCatalogItems);
  const loading = useSelector(selectIsLoading);

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  const location = useLocation();
  const rowData = location.state as AdminCatalogTableRow;
  const nav = useNavigate();

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb
            title={t("CATALOGS.ADD")}
            subTitle={t("CATALOGS.DETAILS_TITLE")}
            onBackClick={() => nav("/catalogs")}
          />
          <CatalogDetails id={rowData?.id} />
          <ActionBar />
          <CatalogItemsTable rows={rows} loading={loading} />
        </Box>
      </Box>
      <AddCatalogItemModal />
    </Box>
  );
};

export default AdminCatalogItems;
